import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-text-expander',
  templateUrl: './text-expander.component.html',
  styleUrl: './text-expander.component.scss'
})
export class TextExpanderComponent {
  @Input() fullText!: string;
  isExpanded: boolean = false;
  maxLength: number = 50;

  get isTruncated(): boolean {
    return !this.isExpanded && this.fullText.length > this.maxLength;
  }

  get displayText(): string {
    return this.isTruncated
      ? this.fullText.slice(0, this.maxLength)
      : this.fullText;
  }

  toggleText(): void {
    this.isExpanded = !this.isExpanded;
  }
}
